import {Component, Inject, inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {HeaderService} from "../../components/header/services/header.service";
import {AsyncPipe, CommonModule, NgIf, NgOptimizedImage} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {HeaderThemeEnum} from "../../components/header/enum/theme.enum";
import {ArtImageComponent} from "../../libs/art-image/art-image.component";
import {ArtFooterComponent} from "../get-art/components/art-footer/art-footer.component";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ArtImageSliderComponent} from "../../libs/art-image-slider/art-image-slider.component";
import {ImageService} from "../../services/image/image.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {ArtImageFadeAnimatedComponent} from "../../libs/art-image-fade-animated/art-image-fade-animated.component";
import {ImageWithTagInterface} from "../../types/image-with-tag/image-with-tag.interface";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    NgOptimizedImage,
    MatButton,
    MatIcon,
    ArtImageComponent,
    ArtFooterComponent,
    MatProgressSpinner,
    ArtImageSliderComponent,
    AsyncPipe,
    NgIf,
    ArtImageFadeAnimatedComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {

  private dialog = inject(MatDialog);
  private headerService = inject(HeaderService);
  private router = inject(Router);
  private imageService = inject(ImageService);

  data: any = {} as ImageWithTagInterface;

  isLoading = new BehaviorSubject<boolean>(true);

  private subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any // Inject platformId to determine the environment
  ) {}

  ngOnInit() {
    // console.log('DDDD');
    const imageWithTag = this.route.snapshot.data['imageData'];

    this.data.image = imageWithTag.image;

    // this.data.tags = imageWithTag.tags.map((v: { title: any; }) => v.title);
    this.data.tags = imageWithTag.tags;

    this.setHeaderColor();
    // if (isPlatformBrowser(this.platformId)) {
    //   const sub = interval(4000)
    //     .pipe(switchMap(() => {
    //       console.log('Fetching data at', new Date());
    //       this.isLoading.next(true);
    //       return this.imageService.getRandomImageWithTags();
    //     }))
    //     .subscribe(imageTags => {
    //       console.log('Received data at', new Date());
    //       // this.image = imageTags.image;
    //       setTimeout(() => this.image = imageTags.image, 500); // 500ms delay for fade-out
    //       // @ts-ignore
    //       this.tags = imageTags.tags.map(v => v.title);
    //       this.isLoading.next(false);
    //     });
    //
    //   this.subscription.add(sub);
    //
    // } else {
    //   this.imageService.getRandomImageWithTags(true).subscribe(imageTags => {
    //     this.image = imageTags.image;
    //     // @ts-ignore
    //     this.tags = imageTags.tags.map(v => v.title);
    //   });
    // }

  }

  ngOnDestroy() {
    this.headerService.setHeaderTheme(HeaderThemeEnum.black);
    this.subscription.unsubscribe();
  }

  takeSurvey() {
    this.router.navigate(['/get-art'], {fragment: '1'}).then();
    // let dialogRef = this.dialog.open(SurveyComponent);
    // dialogRef.beforeClosed().subscribe(result => {
    //   this.router.navigate(['/get-art']).then();
    // })
  }

  private setHeaderColor() {
    this.headerService.setHeaderTheme(HeaderThemeEnum.transparent);
  }

}

